import { render, staticRenderFns } from "./platformBox.vue?vue&type=template&id=7e2bf1b8&scoped=true&"
import script from "./platformBox.vue?vue&type=script&lang=js&"
export * from "./platformBox.vue?vue&type=script&lang=js&"
import style0 from "./platformBox.vue?vue&type=style&index=0&id=7e2bf1b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2bf1b8",
  null
  
)

export default component.exports